import { useState, useEffect } from 'react'
import css from './sass/createedit.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import { handleEnterKey } from '../components/utils'
import { adminValidateMarketingEffort } from './auctionsadminutil'

export default function InputMarketingEffort({ marketingEffortNumber, setMarketingEffortNumber, marketingEffortName, setMarketingEffortName, 
  setMarketingEffortInput, marketingEffortInput, isReadOnly, auction, auctionChanges }) {
    
  const inputValue = (value) => value ?? ''

  //needs effort is for the saved or input value
  const [needsEffort, setNeedsEffort] = useState(false)

  const [invalidMarketingEffort, setInvalidMarketingEffort] = useState(true)

  const [searchResults, setSearchResults] = useState([])
  const [showSearchResults, setShowSearchResults] = useState(true)
  const [invalidSearch, setInvalidSearch] = useState(false)

  const [isSearching, setIsSearching] = useState(false)

  // Initialize marketing effort values on mount or when auction changes
  useEffect(() => {

    if (auctionChanges !== null) {
      //if there are changes from session storage, load them
      const nameHasLength = auctionChanges?.marketingEffortName?.length > 0
      const numberHasLength = auctionChanges?.marketingEffortNumber?.length > 0
      const inputHasLength = auctionChanges?.marketingEffortInput?.length > 0

      if (nameHasLength && numberHasLength) {
        setMarketingEffortName(auctionChanges.marketingEffortName)
        setMarketingEffortNumber(auctionChanges.marketingEffortNumber)
        setInvalidMarketingEffort(false)
        setShowSearchResults(true)
      }
      if ((!nameHasLength && !numberHasLength) && inputHasLength) {
        setMarketingEffortNumber('')
        setMarketingEffortName('')
        setMarketingEffortInput(auctionChanges.marketingEffortInput)
        setInvalidMarketingEffort(false)
        setShowSearchResults(false)
      }
    } else {
      //if there are no auction changes, evaluate using loaded values from the db

      const storedNameHasLength = auction?.MarketingEffortName?.length > 0
      const storedNumberHasLength = auction?.MarketingEffortNumber?.length > 0

      if (storedNameHasLength && storedNumberHasLength) {
        setMarketingEffortName(auction?.MarketingEffortName)
        setMarketingEffortNumber(auction?.MarketingEffortNumber)
        setInvalidMarketingEffort(false)
        setShowSearchResults(true)
      } else {
        setMarketingEffortName(auction?.MarketingEffortName)
        setMarketingEffortNumber(auction?.MarketingEffortNumber)
        setInvalidMarketingEffort(true)
        setShowSearchResults(false)
      }
      
      const newValue = convertSavedToInput()
      setMarketingEffortInput(newValue)
      
    }
  }, [auction?.AuctionId])

  // Update needsEffort state when marketing effort name changes
  useEffect(() => {

    if (marketingEffortName === '' || marketingEffortName === null || marketingEffortName === undefined) setNeedsEffort(true)
    else {
      setNeedsEffort(false)
      // Don't update marketingEffortInput here - it causes issues
      // if (auctionChanges !== null) setMarketingEffortInput(auctionChanges?.marketingEffortInput)
      // else setMarketingEffortInput(marketingEffortNumber)
    }
    
  }, [marketingEffortName])

  useEffect(() => {

    //check to see if search results is an object (has results)
    if (typeof searchResults === "object" && searchResults !== null && !Array.isArray(searchResults)) {

      if (searchResults?.marketingEffortName?.length > 0) {
        selectMarketingEffort()
        setInvalidSearch(false)
      } else {
        setInvalidSearch(true)
        setMarketingEffortName('')
        removeMarketingEffort()
      }
    }
  }, [searchResults, setMarketingEffortName])

  //to convert the saved value inside marketing effort number into the value for the input field
  const convertSavedToInput = () => {
    const regex = /^M-(\d{1,6})$/ // Regex: starts with M-, followed by 1 to 6 digits, and nothing else
    const checkString = marketingEffortNumber ? marketingEffortNumber : ''
    const match = checkString.match(regex)
    if (!match) return ""
    // match[1] contains only the numeric portion
    const newNumber = match[1]
    return newNumber
  }

  const validateMarketingEfforts = async () => {
    setIsSearching(true)
    setInvalidSearch(false)
    const query = marketingEffortInput.toLowerCase()
    const efforts = await adminValidateMarketingEffort(query)
    setIsSearching(false)    
    setShowSearchResults(true)
    setSearchResults(efforts)
  }

  const selectMarketingEffort = () => {
    setMarketingEffortNumber(`M-${marketingEffortInput}`)
    setMarketingEffortName(searchResults?.marketingEffortName)
    setInvalidMarketingEffort(false)
  }

  const removeMarketingEffort = () => {

    if (isReadOnly) return

    const newValue = convertSavedToInput()
    setMarketingEffortInput(newValue)
    setMarketingEffortName('')
    setMarketingEffortNumber('')
    setInvalidMarketingEffort(true)
    setShowSearchResults(false)
  }

  return (
    <>
      <div className={css['selected-fund-header']}>
        <h5 className={css['sub-header']}>Marketing Effort Information</h5>
        {needsEffort ? <p className={css['error-text']}>No marketing effort selected.</p> : 
        <p className={`${css['red-button']} ${isReadOnly ? css['red-button-disabled'] : ''}`} 
          onClick={() => removeMarketingEffort()}> Remove Marketing Effort</p>}
      </div>

        { (needsEffort && !marketingEffortName?.length > 0) && <>
          <p>Enter a marketing effort value below, the click Validate to confirm your entry.</p>
          <div className={css["fund-search-input"]}>
            <input id="editAuctionMarketingEffortNumber" type='text'
              placeholder='e.g. 45735'
              value={inputValue(marketingEffortInput)}
              disabled={isReadOnly || isSearching}
              onKeyDown={(e) => handleEnterKey(e, validateMarketingEfforts)}
              onChange={(e) => setMarketingEffortInput(e.target.value)} />
            <button className={`${themeCss['button']} ${themeCss['FilledBlue']}`} disabled={isReadOnly || isSearching}
              onClick={()=>validateMarketingEfforts()}> VALIDATE </button>
            {isSearching && <p className={css['fund-search-searching']}>Validating...</p>}
            { invalidSearch && <p className={css['error-text']}>Invalid Marketing Effort. Please make sure it has been activated.</p>}
          </div>
          </>}

      {showSearchResults && <div>
        {!invalidMarketingEffort && <>
          <div className={css['edit-item-input']}>
            <label>Marketing Effort</label>
            <input id="editAuctionMarketingEffort" type='text'
              value={inputValue(marketingEffortName)}
              disabled={true} />
          </div>
        </>}
      </div>} 
    </>
  )
}
